import { render, staticRenderFns } from "./Masterplan.vue?vue&type=template&id=a823b576&scoped=true&"
import script from "./Masterplan.vue?vue&type=script&lang=js&"
export * from "./Masterplan.vue?vue&type=script&lang=js&"
import style0 from "./Masterplan.vue?vue&type=style&index=0&id=a823b576&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a823b576",
  null
  
)

export default component.exports